/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import { useSelector } from 'react-redux';
import { Form } from 'semantic-ui-react';
import 'react-datepicker/dist/react-datepicker.css';
import DatePickerLayout from '../../../../components/elements/DatePicker';

const VideogalleryModal = ({
  t,
  recordID,
  title,
  setTitle,
  titleEn,
  setTitleEn,
  publicationDate,
  setPublicationDate,
  filmlocation,
  handleOnSelectCountry,
  filmingLocation,
  keywords,
  setKeywords,
  showPreview,
  applyErrorClass,
  link,
  values,
  setLink,
  doc,
  onUpdate,
  onChange,
  setGridModalupdate,
  gridModalupdate,
}) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const todayDate = new Date();

  return (
    <>
      {gridModalupdate ? (
        <>
          <MDBModal tabIndex="-1" show={gridModalupdate} setShow={setGridModalupdate}>
            <MDBModalDialog className="flex justify-center items-center">
              <MDBModalContent className="w-auto bg-green-50 sm:w-[50vw] md:w-[80vw] lg:w-[100vw]">
                <Form className="flex sm:max-w-[50vw] md:max-w-[60vw] lg:w-[60vw]  flex-col justify-center items-center">
                  <MDBModalHeader>
                    <MDBModalTitle className="text-customgreen font-semibold">
                      {t('update')} {t('navItem_videoGallery')}
                    </MDBModalTitle>
                    {/* <MDBBtn type="button" className="btn-close" color="none" onClick={toggleShowCreate}></MDBBtn> */}
                  </MDBModalHeader>
                  <MDBModalBody>
                    <div className="container-fluid bd-example-row">
                      <div className="row" style={{ marginBottom: '10px' }}>
                        <div className="col-md-6 col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('cms_title')} : </label>
                            <input
                              type="text"
                              name="title"
                              value={title}
                              className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              onChange={(e) => setTitle(e.target.value)}
                              placeholder={t('cms_title')}
                            />
                          </Form.Field>
                        </div>
                        <div className="col-md-6 col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('Title En')} : </label>
                            <input
                              type="text"
                              name="title"
                              value={titleEn}
                              className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              onChange={(e) => setTitleEn(e.target.value)}
                              placeholder={t('Title En')}
                            />
                          </Form.Field>
                        </div>
                      </div>
                      <div className="row" style={{ marginBottom: '10px' }}>
                        <div className="col-md-6 form-group flex flex-col">
                          {/* <label>{ t('cms_publicationDate') } :</label> */}

                          <DatePickerLayout
                            label={'cms_publicationDate'}
                            selectedDate={publicationDate}
                            keyValue={'to'}
                            dateTo={publicationDate}
                            setDateTo={setPublicationDate}
                            maxDate={todayDate}
                          />
                        </div>
                        <div className="col-md-6 ms-auto col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('cms_keywords')} : </label>
                            <input
                              type="text"
                              name="keywords"
                              value={keywords}
                              onChange={(e) => setKeywords(e.target.value)}
                              className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              placeholder={t('cms_keywords')}
                            />
                          </Form.Field>
                        </div>
                      </div>
                      <div className="row" style={{ marginBottom: '10px' }}>
                        <div className="col-md-6 ms-auto col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('cms_filmingLocation')} : </label>
                            <input
                              type="text"
                              disabled
                              name="filmLocation"
                              value={isActive ? filmingLocation?.ar_SA : filmingLocation?.en_US}
                              className=" border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  cursor-not-allowed"
                              // onChange={(selectedCountry) => handleOnSelectCountry(selectedCountry)}
                              placeholder={t('cms_filmingLocation')}
                            />
                            {/* <select
                              name="filmLocation"
                              value={filmlocation}
                              required
                              className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              onChange={(selectedCountry) => handleOnSelectCountry(selectedCountry)}
                              placeholder={t('cms_filmingLocation')}
                            >
                              <option value={0}>--{t('Select Country')}--</option>
                              {filmingLocation && filmingLocation.length > 0 ? (
                                filmingLocation?.map((item) => {
                                  return (
                                    <option key={item.countryID} value={item?.countryName}>
                                      {isActive ? item?.ar_SA : item?.countryName}
                                    </option>
                                  );
                                })
                              ) : (
                                <option>{t('Select country')}</option>
                              )}
                            </select> */}
                          </Form.Field>
                        </div>

                        <div className="col-md-6 ms-auto col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('Video Link')} : </label>
                            <input
                              type="text"
                              name="link"
                              value={link}
                              className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              onChange={(e) => setLink(e.target.value)}
                              placeholder={t('cms_link')}
                            />
                          </Form.Field>
                        </div>
                      </div>
                    </div>
                  </MDBModalBody>
                  <MDBModalFooter className="flex justify-center">
                    <button
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                      onClick={() => onUpdate(recordID)}
                    >
                      {t('Submit')}
                    </button>
                    <button
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                      onClick={() => setGridModalupdate(false)}
                    >
                      {t('close')}
                    </button>
                  </MDBModalFooter>
                </Form>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        </>
      ) : null}
    </>
  );
};

export default VideogalleryModal;
